import { constraints } from '@components/Gallery/Common/SlideImage/constants'

interface GetConstraintsProps {
  hasHeightConstraint?: boolean
  hasDesktopSidebar?: boolean
  isInRecipe?: boolean
}

const getConstraints = ({
  hasHeightConstraint = false,
  hasDesktopSidebar = false,
  isInRecipe = false,
}: GetConstraintsProps) => {
  return constraints[
    isInRecipe
      ? 'inRecipe'
      : !hasDesktopSidebar
      ? 'noDesktopSidebar'
      : 'default'
  ][!hasHeightConstraint ? 'noHeightConstraint' : 'default']
}

export { getConstraints }
